module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag1-agnostic.dfac6c51.gif";